import { render, staticRenderFns } from "./ToastArea.vue?vue&type=template&id=a0946ed8&"
import script from "./ToastArea.vue?vue&type=script&lang=ts&"
export * from "./ToastArea.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports